import { Component, OnInit } from '@angular/core';
import { LangService } from 'src/app/services/lang/lang.service';
import { WinService } from 'src/app/services/win.service'; 
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-cart-empty-state',
  templateUrl: './cart-empty-state.component.html',
  styleUrls: ['./cart-empty-state.component.scss']
})
export class CartEmptyStateComponent implements OnInit {

	env = environment;

	constructor(
		public lang: LangService,
	    public winService: WinService
	) { }

	ngOnInit() {
	}

}
